var exports = {
  "Ew": "MessageAttachments.module__forwardedContainer___Y3dwRn",
  "iE": "MessageAttachments.module__forwardedBar___Y3dwRn",
  "Q$": "MessageAttachments.module__forwardedContent___Y3dwRn",
  "Sd": "MessageAttachments.module__forwardedHeader___Y3dwRn",
  "Q_": "MessageAttachments.module__forwardedIcon___Y3dwRn",
  "nQ": "MessageAttachments.module__forwardedLabel___Y3dwRn",
  "KK": "MessageAttachments.module__attachmentsContainer___Y3dwRn",
  "R$": "MessageAttachments.module__urlEmbedSpoiler___Y3dwRn",
  "eb": "MessageAttachments.module__forwardedSourceButton___Y3dwRn",
  "O_": "MessageAttachments.module__forwardedSourceLabel___Y3dwRn",
  "wM": "MessageAttachments.module__forwardedSourceInfo___Y3dwRn",
  "Lk": "MessageAttachments.module__forwardedSourceIcon___Y3dwRn",
  "ZF": "MessageAttachments.module__forwardedSourceAvatar___Y3dwRn",
  "qM": "MessageAttachments.module__forwardedSourceGuildIcon___Y3dwRn",
  "T5": "MessageAttachments.module__forwardedSourceChevron___Y3dwRn",
  "V0": "MessageAttachments.module__forwardedSourceName___Y3dwRn",
  "ye": "MessageAttachments.module__stickersContainer___Y3dwRn",
  "Bd": "MessageAttachments.module__stickerWrapper___Y3dwRn",
  "Rq": "MessageAttachments.module__stickerWrapperInteractive___Y3dwRn",
  "HF": "MessageAttachments.module__stickerImage___Y3dwRn",
};

module.exports = exports;
